<template>
  <div class="navlistbox bg" :class="{ show: show }">
    <div class="tabs">
      <div class="team">
        
        <div class="controls-row">
          <div class="form-radio-inline">
            <label class="form-radio-label">
              <input
                type="radio"
                class="form-radio-input"
                value="name"
                v-model="types"
                @change="changeType"
              />Имена
            </label>
            <label class="form-radio-label">
              <input
                type="radio"
                class="form-radio-input"
                value="number"
                v-model="types"
                @change="changeType"
              />Номера
            </label>
          </div>

          <div class="form-radio-inline status-group">
            <label class="form-radio-label color-start">
              <input
                type="radio"
                class="form-radio-input"
                value="start"
                v-model="statusType"
              />Старт
            </label>          
            <label class="form-radio-label color-bench">
              <input
                type="radio"
                class="form-radio-input"
                value="bench"
                v-model="statusType"
              />Лавка
            </label>
            <label class="form-radio-label color-possible">
              <input
                type="radio"
                class="form-radio-input"
                value="possible"
                v-model="statusType"
              />Поссибл
            </label>
            <label class="form-radio-label color-squad">
              <input
                type="radio"
                class="form-radio-input"
                value="squad_list"
                v-model="statusType"
              />Заявка
            </label>
          </div>
        </div>

        <textarea
          v-model="txt"
          @keyup.enter.prevent="GO()"
          @keyup.ctrl.enter.prevent="newLine"
          ref="textarea"
        />
        <button class="btn btn-success" @click="GO()">GO</button>
      </div>
    </div>
  </div>
</template>

<script>
import latinize from "latinize";

export default {
  name: "addListBox",
  data: () => ({
    txt: "",
    types: "name",
    statusType: "start", // По умолчанию Старт (Красные точки)
    msg: "",
  }),
  props: {
    team: { type: Object },
    show: { type: Boolean, default: false },
  },
  methods: {
    changeType() {
      this.txt = "";
      this.$refs.textarea.focus();
    },
    newLine(e) {
      let caret = e.target.selectionStart;
      e.target.setRangeText("\n", caret, caret, "end");
      this.txt = e.target.value;
    },
    // ФУНКЦИЯ АСИНХРОННАЯ
    async GO() {
      const getLevenshteinDistance = (a, b) => {
        if (a.length === 0) return b.length;
        if (b.length === 0) return a.length;
        const matrix = [];
        for (let i = 0; i <= b.length; i++) matrix[i] = [i];
        for (let j = 0; j <= a.length; j++) matrix[0][j] = j;
        for (let i = 1; i <= b.length; i++) {
          for (let j = 1; j <= a.length; j++) {
            if (b.charAt(i - 1) === a.charAt(j - 1)) {
              matrix[i][j] = matrix[i - 1][j - 1];
            } else {
              matrix[i][j] = Math.min(
                matrix[i - 1][j - 1] + 1,
                matrix[i][j - 1] + 1,
                matrix[i - 1][j] + 1
              );
            }
          }
        }
        return matrix[b.length][a.length];
      };

      // Возвращает -1, если имена не совпали, иначе "стоимость" совпадения
      // (сумма расстояний Левенштейна по словам; 0 — точное совпадение).
      const nameMatchScore = (inputName, dbName) => {
        let cleanInput = inputName.toLowerCase().trim();
        const cleanDb = dbName.toLowerCase().trim();

        if (cleanInput === cleanDb) return 0;

        let inputInitials = [];
        const initialsRegex = /(?:^|\s)([a-zа-яё])\.?(?=\s|$)/g;
        let match;
        while ((match = initialsRegex.exec(cleanInput)) !== null) {
          inputInitials.push(match[1]);
        }

        let inputWordsStr = cleanInput.replace(initialsRegex, ' ').trim();
        const inputWords = inputWordsStr.split(/[\s\-]+/).filter(w => w.length > 0);
        const dbWords = cleanDb.split(/[\s\-]+/).filter(w => w.length > 0);

        if (inputWords.length === 0) return -1;

        const wordDistance = (iWord, dbWord) => {
          if (iWord === dbWord) return 0;
          const dist = getLevenshteinDistance(iWord, dbWord);
          const allowedTypos = iWord.length <= 4 ? 0 : (iWord.length <= 7 ? 1 : 2);
          return dist <= allowedTypos ? dist : -1;
        };

        let score = 0;
        let matchedDbIndices = new Set();
        let isInputSubset = inputWords.every(iWord => {
          let bestIdx = -1;
          let bestDist = -1;
          dbWords.forEach((dbWord, index) => {
            if (matchedDbIndices.has(index)) return;
            const d = wordDistance(iWord, dbWord);
            if (d !== -1 && (bestDist === -1 || d < bestDist)) {
              bestDist = d;
              bestIdx = index;
            }
          });
          if (bestIdx !== -1) {
            matchedDbIndices.add(bestIdx);
            score += bestDist;
            return true;
          }
          return false;
        });

        let isDbSubset = false;
        if (!isInputSubset) {
          score = 0;
          isDbSubset = dbWords.every(dbWord => {
            let bestDist = -1;
            inputWords.forEach(iWord => {
              const d = wordDistance(iWord, dbWord);
              if (d !== -1 && (bestDist === -1 || d < bestDist)) bestDist = d;
            });
            if (bestDist === -1) return false;
            score += bestDist;
            return true;
          });
        }

        if (!isInputSubset && !isDbSubset) return -1;

        if (inputInitials.length > 0 && isInputSubset) {
          let unmatchedDbWords = dbWords.filter((_, index) => !matchedDbIndices.has(index));
          let allInitialsMatched = inputInitials.every(initial => {
            let foundIdx = unmatchedDbWords.findIndex(dbW => dbW.startsWith(initial));
            if (foundIdx !== -1) {
              unmatchedDbWords.splice(foundIdx, 1);
              return true;
            }
            return false;
          });
          if (!allInitialsMatched) return -1;
        }

        // Совпадение вида "состав ⊆ ввод" слабее — проигрывает при равном счёте
        return isInputSubset ? score : score + 0.5;
      };

      // Берём ОДНОГО лучшего кандидата из состава, а не всех подходящих:
      // иначе "Gilli" цепляет заодно и "Galli" (расстояние 1).
      const findBestPlayer = (name, transform) => {
        const t = transform || ((v) => v);
        let best = null;
        let bestScore = -1;
        this.team.squad.forEach((item) => {
          const s = nameMatchScore(t(name), t(item.name));
          if (s === -1) return;
          if (best === null || s < bestScore) {
            best = item;
            bestScore = s;
          }
        });
        return best;
      };

      let txt;
      let playersToSave = []; 

      if (this.types === "name") {
        txt = this.txt
          .split(/\n|\r|\n\r|,\s|,|;\s|;|\s-\s/)
          .filter((item) => (item !== "" ? true : false));
        
        txt = txt.map((item) =>
          item
            .trim()
            .replace(/^[^:]+:\s*/, "")                
            .replace(/\s*\(\d+\)/g, "")                
            .replace(/\s*\([A-Za-zА-Яа-яЁё]\)/g, "")  
            .replace(/^[0-9]{1,3}[\s.\-]*/, "")        
            .trim()
        );

        txt = txt.filter((item) => item !== "");

        let err = [];

        txt.forEach((name) => {
          const player = findBestPlayer(name);
          if (player) playersToSave.push(player);
          else err.push(name);
        });

        if (err.length > 0) {
          const remainingErr = [];
          err.forEach((name) => {
            const player = findBestPlayer(name, latinize);
            if (player) playersToSave.push(player);
            else remainingErr.push(name);
          });
          err = remainingErr;
        }

        if (err.length > 0) {
          this.txt = `Не могу найти: ${err.join(", ")}`;
        } else {
          this.txt = "";
        }
      } else {
        txt = this.txt
          .split(/\n|\r|\n\r|,\s|,|;\s|;|\s|\s+/)
          .filter((item) => (item !== "" && Number(item) >= 0 ? true : false));
        txt = txt.map((item) =>
          Number(item.replace(/\.|\s\.|\.\s|\s\.\s/, "").trim())
        );

        const err = [];
        txt.forEach((num) => {
          let found = false;
          this.team.squad.forEach((item) => {
            if (Number(item.shirtnumber) === num) {
              playersToSave.push(item);
              found = true;
            }
          });
          if (!found) err.push(num);
        });

        if (err.length > 0) {
          this.txt = `Не могу найти: ${err.join(", ")}`;
        } else {
          this.txt = "";
        }
        this.$emit("hide");
      }

      // === МАГИЯ РАСПРЕДЕЛЕНИЯ ДАННЫХ (ЧЕРЕЗ BATCH) ===
      if (playersToSave.length > 0) {
        if (this.statusType === "squad_list" || this.statusType === "possible") {
          
          // Определяем, какой цвет закрашивать
          const targetColor = this.statusType === "squad_list" ? "black" : "lightblue";

          // Вызываем экшен для закрашивания кружочков (черных или светло-синих)
          const payload = playersToSave.map(player => ({
            teamsId: this.team._id,
            id: player.shirtnumber,
            color: targetColor,
            name: player.name
          }));
          
          this.$store.dispatch("SAVE_COLOR_BATCH", payload);

        } else {
          // Старт или Лавка - шлем массово в SAVE_LINEUP_BATCH
          const finalStatus = this.statusType === "start" ? null : "squad";

          const payload = playersToSave.map(player => ({
            shirtnumber: player.shirtnumber,
            teamsId: this.team._id,
            lineupStatus: finalStatus, 
            name: player.name
          }));
          
          this.$store.dispatch("SAVE_LINEUP_BATCH", payload);
        }
      }
    },
  },
};
</script>

<style lang="sass">
@import "../assets/vars"

.bg
  background-color: $RoundGreen
.navlistbox
  display: block
  visibility: hidden
  opacity: 0
  position: absolute
  padding: 15px
  top: 40px
  right: -20px
  width: 0px
  height: 0px
  transition: all .3s linear
  z-index: 10000
  &.show
    visibility: visible
    opacity: 1
    width: 380px /* Чуть расширили, чтобы влезла новая кнопка */
    min-height: 200px
    height: auto

.controls-row
  display: flex
  flex-direction: row
  align-items: center
  margin-bottom: 5px
  border-bottom: 1px solid rgba(255, 255, 255, 0.2)
  padding-bottom: 10px

.status-group
  margin-left: 15px
  padding-left: 15px
  border-left: 1px solid rgba(255, 255, 255, 0.4)

.color-start
  color: #a90d0d
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3)
  font-weight: bold
.color-possible
  color: #87CEFA /* Светло-синий цвет, подходящий под lightblue */
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3)
  font-weight: bold
.color-bench
  color: #fffacd
.color-squad
  color: #333333

.btn-tabs
  display: flex
  justify-content: left
.tabs
  div
    textarea
      width: 100%
      height: 130px
      background-color: rgba(white,.99)
.form-radio-label
  margin: 0 8px /* Чуть уменьшили отступ, чтобы всё поместилось */
  display: flex
  align-self: center
  input
    margin-right: 5px
.err
  color: $RoundRed
</style>